import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStandardBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 332,
	height: 114,
	viewBox: "0 0 332 114",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_f_571_32188)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V102C328 106.418 324.418 110 320 110H12C7.58172 110 4 106.418 4 102V12Z",
					fill: "url(#paint0_linear_571_32188)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V102C328 106.418 324.418 110 320 110H12C7.58172 110 4 106.418 4 102V12Z",
					fill: "white",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V102C328 106.418 324.418 110 320 110H12C7.58172 110 4 106.418 4 102V12Z",
					fill: "url(#paint1_radial_571_32188)",
					fillOpacity: .8
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_571_32188",
				x: 0,
				y: 0,
				width: 332,
				height: 114,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2,
						result: "effect1_foregroundBlur_571_32188"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_571_32188",
				x1: 4,
				y1: 57,
				x2: 328,
				y2: 57,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C6FFB5" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2355EE"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_571_32188",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(166 4) rotate(33.1976) scale(193.598 63.3375)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B48EFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B48EFF",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgStandardBackground);
export default ForwardRef;
